export default {
    baseStyle: {
        trigger: {
            '[data-bv-show="rating_summary"] .bv_main_container': {
                marginTop: '0 !important',
                '.bv_numReviews_text': {
                    color: 'black.100 !important',
                    fontSize: '14px !important',
                    fontWeight: '300 !important',
                    letterSpacing: '0.07px !important',
                    textUnderlineOffset: '4px',
                    textDecoration: 'underline !important',
                    transition: 'color, 0.3s ease'
                }
            },
            '&:hover': {
                cursor: 'pointer',
                '.bv_main_container_row_flex .bv_avgRating_component_container': {
                    textDecoration: 'underline !important',
                    color: 'teal.600 !important',
                    textUnderlineOffset: '4px'
                },
                '.bv_main_container_row_flex .bv_numReviews_text': {
                    textDecoration: 'underline !important',
                    color: 'teal.600 !important',
                    textUnderlineOffset: '4px'
                }
            }
        }
    }
}
